






















import { Component, Prop, Vue } from 'vue-property-decorator';

import { Product, Promo } from '@/store/modules/lib';

@Component
export default class LinkList extends Vue {

  @Prop({ type: Array, default: [] }) protected promo!: Promo[];

  protected get links() {

    return this.promo
      .filter(promo => promo.type == 'link')
      .sort((a:Promo, b:Promo) => {
        return a.order > b.order
          ? 1
          : (a.order < b.order)
            ? -1
            : 0;
      });

  }

}

